import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout.jsx';

import ScrollToTop from './components/ScrollToTop/ScrollToTop.jsx';
import Home from './components/Home/Home.jsx';
import About from './components/About/About.jsx';
import Services from './components/Services/Services.jsx';
import Products from './components/Products/Products.jsx';
import Contact from './components/Contact/Contact.jsx';
import Valncia from './components/AllProducts/Valncia.jsx';
import Navel from './components/AllProducts/Navel.jsx';
import Lemon from './components/AllProducts/Lemon.jsx';
import Chili from './components/AllProducts/Chili';
import Grapes from './components/AllProducts/Grapes';
import Onion from './components/AllProducts/Onion';
import Strawberries from './components/AllProducts/Strawberries';
import Carrots from './components/AllProducts/Carrots';
import Pomegranate from './components/AllProducts/Pomegranate.jsx';
import Mandarin from './components/AllProducts/Mandarin.jsx';
import Capsicum from './components/AllProducts/Capsicum.jsx';
import Garlic from './components/AllProducts/Garlic.jsx';
import Potato from './components/AllProducts/Potato.jsx';
import Barhi from './components/AllProducts/Barhi.jsx';
import Capucha from './components/AllProducts/Capucha.jsx';
import Frozen from './components/Frozen/Frozen.jsx';
import Fries from './components/FrozenComponents/Fries';
import Okra from './components/FrozenComponents/Okra';
import Molokhia from './components/FrozenComponents/Molokhia.jsx';
import Mango from './components/FrozenComponents/Mango.jsx';
import Guava from './components/FrozenComponents/Guava.jsx';
import Peas from './components/FrozenComponents/Peas.jsx';
import Broccoli from './components/FrozenComponents/Broccoli';
import Bottoms from './components/FrozenComponents/Bottoms.jsx';
import FrozenStrawberries from './components/FrozenComponents/FrozenStrawberries.jsx';
import Cauliflower from './components/FrozenComponents/Cauliflower.jsx';
import SweetPotato from './components/AllProducts/SweetPotato';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="story" element={<Services />} />
          <Route path="fresh-products" element={<Products />} />
          <Route path="frozen-products" element={<Frozen />} />
          <Route path="contact" element={<Contact />} />
          <Route path="valincia" element={<Valncia />} />
          <Route path="navel" element={<Navel />} />
          <Route path='lemon' element={<Lemon />} />
          <Route path='chili' element={<Chili />} />
          <Route path='grapes' element={<Grapes />} />
          <Route path='onion' element={<Onion />} />
          <Route path='strawberries' element={<Strawberries />} />
          <Route path='carrot' element={<Carrots />} />
          <Route path='pomegranate' element={<Pomegranate />} />
          <Route path='mandarin' element={<Mandarin />} />
          <Route path='capsicum' element={<Capsicum />} />
          <Route path='garlic' element={<Garlic />} />
          <Route path='potato' element={<Potato />} />
          <Route path='sweet-potato' element={<SweetPotato />} />
          <Route path='barhi' element={<Barhi />} />
          <Route path='capucha' element={<Capucha />} />
          <Route path='fries' element={<Fries />} />
          <Route path='okra' element={<Okra />} />
          <Route path='molokhia' element={<Molokhia />} />
          <Route path='mango' element={<Mango />} />
          <Route path='guava' element={< Guava />} />
          <Route path='peas' element={<Peas />} />
          <Route path='broccoli' element={<Broccoli />} />
          <Route path='cauliflower' element={<Cauliflower />} />
          <Route path='frozen-strawberries' element={<FrozenStrawberries />} />
          <Route path='artichoke-bottoms' element={<Bottoms />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
